import {
  FillLayer,
  FillPaint,
  LinePaint,
  SymbolLayer,
  SymbolLayout,
} from 'mapbox-gl';

export default {
  stateLayer: {
    id: 'states',
    type: 'fill',
    source: 'austates',
    paint: {
      'fill-color': '#F5F9FF',
    },
  } as FillLayer,
  stateOutlines: {
    'line-color': '#C6CEDA',
    'line-width': 1.5,
  } as LinePaint,
  stateHOutlines: {
    'line-color': '#0000FE',
    'line-width': 1.5,
  } as LinePaint,
  stateHighlight: {
    id: 'states-highlight',
    type: 'fill',
    source: 'austates',
    paint: {
      'fill-color': '#E7F1FC',
    },
  } as FillLayer,
  stateName: {
    id: 'poi-labels',
    type: 'symbol',
    source: 'austateslabels',
    layout: {
      'text-field': ['get', 'STATE_NAME_LABEL'],
      'text-justify': 'auto',
      'text-font': ['ABC Diatype Regular'],
    },
  } as SymbolLayer,
  blueCircle: {
    'fill-color': '#0000FE',
    'fill-opacity': 0.15,
  } as FillPaint,
  blueOutline: {
    'line-color': '#0000FE',
    'line-width': [
      'interpolate',
      ['exponential', 0.5],
      ['zoom'],
      6,
      1,
      7,
      2,
    ],
  } as LinePaint,
  icon: {
    'icon-image': 'helper',
    'icon-size': [
      'interpolate',
      ['exponential', 0.5],
      ['zoom'],
      6,
      0.7,
      7,
      1,
    ],
    'icon-allow-overlap': true,
  } as SymbolLayout,
};
